import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M16 3H4v2h5v12h2V5h5z'],
  height: 20,
  width: 20,
});
